import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";

interface CommunityStatsProps {
  useCases: number;
  contributors: number;
  aiTools: number;
}

export const CommunityStats: FC<CommunityStatsProps> = ({ useCases, contributors, aiTools }) => (
  <Row className="use-case-browse-page__stats" gridGap="S400">
    <div className="use-case-browse-page__stat">
      <Text fontSize="T500" fontWeight="bold">
        {useCases}
      </Text>
      <Text fontSize="T100" color="var(--st-dt-color-text-secondary)">
        {getString("useCases.browsePage.statsUseCases")}
      </Text>
    </div>
    <div className="use-case-browse-page__stat">
      <Text fontSize="T500" fontWeight="bold">
        {contributors}
      </Text>
      <Text fontSize="T100" color="var(--st-dt-color-text-secondary)">
        {getString("useCases.browsePage.statsContributors")}
      </Text>
    </div>
    <div className="use-case-browse-page__stat">
      <Text fontSize="T500" fontWeight="bold">
        {aiTools}
      </Text>
      <Text fontSize="T100" color="var(--st-dt-color-text-secondary)">
        {getString("useCases.browsePage.statsAiTools")}
      </Text>
    </div>
  </Row>
);
